import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { adminApi } from '../../api/admin.js';

export default function Users() {
  const [items, setItems] = useState([]);
  const [roles, setRoles] = useState([]);
  const [search, setSearch] = useState('');
  const [showInvite, setShowInvite] = useState(false);
  const [info, setInfo] = useState(null);
  const [error, setError] = useState(null);
  const [editing, setEditing] = useState(null);

  function refresh() { adminApi.users({ search }).then((d) => setItems(d?.items || [])); }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { refresh(); /* eslint-disable-next-line */ }, [search]);
  useEffect(() => { adminApi.roles().then((d) => setRoles(d?.items || [])); }, []);

  async function invite(e) {
    e.preventDefault();
    setError(null); setInfo(null);
    const fd = new FormData(e.currentTarget);
    try {
      const r = await adminApi.inviteUser({
        name: fd.get('name'),
        email: fd.get('email'),
        roles: ['employee'],
      });
      setInfo(`Invited ${r.user.email}. Temporary password: ${r.tempPassword}`);
      setShowInvite(false);
      e.currentTarget.reset();
      refresh();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed');
    }
  }

  async function toggle(u) {
    if (u.status === 'suspended') await adminApi.reactivateUser(u.id);
    else await adminApi.deactivateUser(u.id);
    refresh();
  }

  async function saveRoles() {
    if (!editing) return;
    await adminApi.setUserRoles(editing.id, editing.roleIds);
    setEditing(null);
    refresh();
  }

  return (
    <section>
      <header className="page-header">
        <h1>Users</h1>
        <button className="btn primary" onClick={() => setShowInvite((s) => !s)}>{showInvite ? 'Close' : '+ Invite User'}</button>
      </header>
      {error && <div className="alert error">{error}</div>}
      {info && <div className="alert info">{info}</div>}

      {showInvite && (
        <form onSubmit={invite} className="card form-card grid-form">
          <label>Name<input name="name" required /></label>
          <label>Email<input name="email" type="email" required /></label>
          <div className="full actions"><button className="btn primary" type="submit">Send invite</button></div>
        </form>
      )}

      <div className="card form-card grid-form">
        <label className="full">Search<input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="name or email" /></label>
      </div>

      <div className="card">
        <table className="data-table">
          <thead><tr><th>Name</th><th>Email</th><th>Roles</th><th>Status</th><th></th></tr></thead>
          <tbody>
            {items.map((u) => (
              <tr key={u.id}>
                <td><strong>{u.name}</strong></td>
                <td className="muted">{u.email}</td>
                <td>{u.roles?.map((r) => <span key={r.id} className="chip" style={{ marginRight: 4 }}>{r.name}</span>)}</td>
                <td><span className={`chip status-${u.status === 'active' ? 'active' : 'cancelled'}`}>{u.status}</span></td>
                <td>
                  <Link to={`/admin/users/${u.id}/supervisor-config`} className="btn ghost small">Supervisor & tags</Link>
                  <button className="btn ghost small" onClick={() => setEditing({ id: u.id, name: u.name, roleIds: (u.roles || []).map((r) => r.id) })}>Roles</button>
                  <button className="btn ghost small" onClick={() => toggle(u)}>{u.status === 'suspended' ? 'Reactivate' : 'Deactivate'}</button>
                </td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={5} className="muted">No users.</td></tr>}
          </tbody>
        </table>
      </div>

      {editing && (
        <div className="card">
          <h3>Roles for {editing.name}</h3>
          <div className="vendor-grid">
            {roles.map((r) => (
              <label key={r.id} className={`vendor-pick ${editing.roleIds.includes(r.id) ? 'picked' : ''}`}>
                <input type="checkbox" checked={editing.roleIds.includes(r.id)} onChange={() => {
                  const next = new Set(editing.roleIds);
                  if (next.has(r.id)) next.delete(r.id); else next.add(r.id);
                  setEditing({ ...editing, roleIds: [...next] });
                }} />
                <span>{r.name}</span>
              </label>
            ))}
          </div>
          <div className="actions">
            <button className="btn ghost" onClick={() => setEditing(null)}>Cancel</button>
            <button className="btn primary" onClick={saveRoles}>Save</button>
          </div>
        </div>
      )}
    </section>
  );
}
